import React, { useEffect, useRef } from "react";
import * as d3 from "d3";
import useResizeObserver from "./useResizeObserver";
import { BrowserView , MobileView} from "react-device-detect";

function FloatingCircles({yearData}){

    if (yearData[0]){
        var yearData = yearData.sort((a,b)=>{return b['Salary Paid']-a['Salary Paid']})
        var employerName = yearData[0]['Employer']
        var calendarYear = yearData[0]['Calendar Year']
    }

    // console.log(root.descendants())
        
      const svgFloatRef = useRef()
      const sideWrapperRef = useRef();
      var sideDimensions = useResizeObserver(sideWrapperRef);  
         
        var circleColor = d3.scaleThreshold().domain([200000,300000,400000,500000,600000,700000,800000,900000]).range(["#F77455","#F567E8","#BDFFED","#F7E146","#6AB7DF","white","white","white","white","white"])   
        
        useEffect(()=>{
            if (!sideDimensions){return}
            if (yearData){

                var width = sideDimensions.width;
                var height = sideDimensions.height;
                var margin_top = 10;
                var margin_right = 10;
                var margin_bottom = 10;
                var margin_left = 10;
                
                // const circles = Array.from({length: 10}, () => ({r: 10 + Math.random() * 10}));
                var dataToBePacked = {name:"root",children:yearData}
                var packedData = d3.hierarchy(dataToBePacked).sum(d=>10)//.sum(d => d.hasOwnProperty("Salary Paid") ? parseInt(d['Salary Paid'])/100000 : 0)
                var treeLayout = d3.treemap().size([width,height])(packedData)
                // console.log("packedData",packedData)
                // console.log("treeLayout",treeLayout)


                const mouseLeaveFloaters = function(e,i){
                    d3.select(".floaterToolTip").transition().remove()
                }
                const svgFloat = d3.select(svgFloatRef.current).attr("width",width).attr("height",height).on("mouseleave",mouseLeaveFloaters)
    
                const mouseOverPerson = function(e,i){
                    d3.select(this).style("opacity",1).attr("stroke-width","1px").attr("stroke","black")
                    // console.log(i.data)
                    var personName = i.data['First Name'] + " " + i.data['Last Name']
                    var jobTitle = i.data['Job Title'];
                    var salaryPaid = i.data['Salary Paid']
                    var taxableBenefit = i.data['Taxable Benefits']
                    var salaryColor = d3.select(this).style('fill');

                    var windowWidth = window.innerWidth;
                    var windowHeight= height;
                    var tipWidth;
                    document.querySelector(".floaterToolTip") ? tipWidth = document.querySelector(".floaterToolTip").offsetWidth : tipWidth = 0
                    var tipHeight;
                    document.querySelector(".floaterToolTip") ? tipHeight = document.querySelector(".floaterToolTip").offsetHeight : tipHeight = 0
                    var posX;
                    e.pageX > 0.4*windowWidth ? posX = e.pageX - tipWidth + 20 : posX = e.pageX + 10
                    var posY;
                    e.pageY > 0.4*windowHeight ? posY = e.pageY - tipHeight - 5 : posY = e.pageY + 10
    
                    
                    d3.selectAll(".floaterToolTip")
                    .data([100])
                    .join("div")
                    .style("position","absolute")
                    .style("top",posY+"px")
                    .style("left",posX+"px")
                    .attr("class","floaterToolTip")
                    // .style("transform","translate(-"+toolTipWidth+"px,0)")
                    // .html(hoverYear + "<br>" + i.key + "<br>" + employerYearCount + " employees <br>" + "Total: $"+Math.round(employerYearTotal).toLocaleString())
                    .html( "<div class = 'person-name'>"+ personName+"</div><div class = 'job-title'>"+jobTitle+"</div><div class='salary-paid'>" + "Salary: $"+Math.round(salaryPaid).toLocaleString() + "</div><div class = taxable-benefits>" + "Taxable Benefits: $" + Math.round(taxableBenefit).toLocaleString() + "</div>" )
                }
    
                const mouseLeavePerson = function(e,i){
                    d3.select(this).attr("stroke-width","0")
                    d3.selectAll(".floaters").style("opacity",0.6)
                    }
                
                svgFloat.selectAll(".floaters")
                    .data(treeLayout.descendants())
                    .join("rect")
                    .on("mouseover",mouseOverPerson)
                    .on("mouseleave",mouseLeavePerson)
                    .attr("class","floaters")
                    .style("stroke-width","0.5px")
                    .style("stroke","white")
                    .attr("fill",(d,i)=>{return circleColor(d.data['Salary Paid'])})
                    // .attr("fill",(d,i)=>{return circleColor(+d['Salary Paid'])})
                    .style("opacity",0.8)
                    .attr("x",(d,i)=>{return d.x0})
                    .attr("y",(d,i)=>{return d.y0})
                    // .attr("transform","translate("+(width - parentSize)/2+","+(height - parentSize)/2+")")
                    .attr("height",(d,i)=>{return d.y1-d.y0})
                    .attr("width",(d,i)=>{return d.x1-d.x0})
                    // .transition()
                    // .delay(10).duration(500)
                    // .attr("r",(d,i)=>{return circleSize(d.data['Salary Paid'])})
            }

            
    }, [sideDimensions,yearData])

    return (
        <React.Fragment>
            <BrowserView viewClassName = "side-graph browserView">
            <div className = "side-graph-wrapper browser" ref = {sideWrapperRef}>
                <div className = "side-graph-title browser">
                    <h4>{employerName} {calendarYear}</h4>
                </div>
                <svg className = "side-graph-svg browser" ref = {svgFloatRef}></svg>
            </div>
            </BrowserView>
            <MobileView viewClassName = "side-graph mobileView">
            <div className = "side-graph-wrapper mobile" ref = {sideWrapperRef}>
                <div className = "side-graph-wrapper mobile" ref = {sideWrapperRef}>
                    <div className = "side-graph-title mobile">
                        <h4>{employerName} {calendarYear}</h4>
                    </div>
                    <svg className = "side-graph-svg mobile" ref = {svgFloatRef}></svg>
                </div>
            </div>
            </MobileView>
        </React.Fragment>
    )
}

export default FloatingCircles